module.exports = __webpack_public_path__ + "img/2023-32.9d0666bd.jpg";